import { createRouter, createWebHistory } from 'vue-router'
import { useProfileStore } from '@/stores/profileStore';

const routes = [
  {
    path: '/',
    component: () => import('@/layout/DefaultLayout.vue'),
    children: [
      {
        path: ':pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../views/NotFound.vue'),
        meta: { title: 'صفحه یافت نشد' }
      },
      {
        path: '/',
        name: 'home',
        component: () => import('../views/article/ArticleView.vue'),
        meta: { title: "انواع تابلو" }
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('../views/profile/MyProfile.vue')
      },
      {
        path: 'sample',
        name: 'sample',
        component: () => import('../views/sample/SampleView.vue'),
        meta: {
          title: "نمونه تابلو"
        }
      },
      {
        path: 'sample/:id/:name/',
        name: 'sampleDetails',
        component: () => import('../views/sample/SampleDetails.vue')
      },
      {
        path: 'board',
        name: 'board',
        component: () => import('../views/board/BoardList.vue'),

      },
      {
        path: 'board/:id/:name/',
        name: 'boardDetails',
        component: () => import('../views/board/BoardDetails.vue')
      },
      {
        path: 'article',
        name: 'article',
        component: () => import('../views/article/ArticleView.vue'),
        meta: { title: "انواع تابلو" }
      }, {
        path: 'article/:id/',
        name: 'articleDetails',
        component: () => import('../views/article/ArticleDetails.vue')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('../views/AboutView.vue'),
        meta: { title: 'درباره ما' }
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('../views/ContactView.vue'),
        meta: { title: 'تماس با ما' }
      }]
  }, {
    path: '/login',
    component: () => import("@/layout/LoginLayout.vue"),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import("@/views/auth/LoginPage.vue")
      }
    ]
  }, {
    path: '/manager',
    component: () => import("@/layout/ManagerLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'managerHome',
        component: () => import("@/views/manager/DefaultView.vue")
      },
      {
        path: 'slider',
        name: 'managerSlide',
        component: () => import("@/views/manager/slider/SliderListView.vue")
      },
      {
        path: 'slider/:id',
        name: 'managerSlideDetails',
        component: () => import("@/views/manager/slider/SliderDetailsView.vue")
      },
      {
        path: 'member',
        name: 'managerMember',
        component: () => import('../views/manager/member/MemberList.vue'),
        children: []
      },
      {
        path: "member/:id",
        name: 'managerMemberDetails',
        component: () => import("../views/manager/member/MemberDetails.vue")
      },
      {
        path: 'article',
        name: 'managerArticleList',
        component: () => import("@/views/manager/article/ArticleList.vue")
      },
      {
        path: 'article/:id',
        name: 'managerArticleDetails',
        component: () => import("@/views/manager/article/ArticleDetails.vue")
      }, {
        path: 'board',
        name: 'managerBoardList',
        component: () => import("@/views/manager/board/BoardList.vue")
      }, {
        path: 'sample',
        name: 'managerSampleList',
        component: () => import("@/views/manager/sample/SampleList.vue")
      },
      {
        path: 'sample/:id',
        name: 'managerSampleDetails',
        component: () => import("@/views/manager/sample/SampleDetails.vue")
      },
      {
        path: 'sample/:id/images',
        name: 'managerSampleImage',
        component: () => import("@/views/manager/sample/SampleImage.vue")
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "is-active", // active class for non-exact links.
  linkExactActiveClass: "is-exactive", // active class for *exact* links
  scrollBehavior(to, from) {
    if (
      (from.name != undefined & from.name != to.name) |
      (from.params.key != undefined & from.params.key != to.params.key)
    ) {
      var elmnt = document.getElementById("topScroll");
      if (typeof elmnt != "undefined" && elmnt != null) {

        return {
          top: elmnt.offsetTop + (elmnt.offsetHeight),
          behavior: 'smooth',
        }
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  const dataProfile = useProfileStore();

  let reLogin = false;
  if (dataProfile.logined) {
    reLogin = (Date.parse(dataProfile.profile.expTime) - Date.now()) / (24 * 60 * 60 * 1000) < 0;
  }
  if (to.meta.requiresAuth & (!dataProfile.logined | reLogin)) {
    next({ path: '/login', query: { last: to.fullPath } });
  } else {
    let documentTitle = `${process.env.VUE_APP_TITLE}`;
    if (to.meta.title) {
      documentTitle = `${to.meta.title} - ${documentTitle}`;
    }
    document.title = documentTitle;
    document.getElementsByTagName("meta")["keywords"].content = "";
    document.getElementsByTagName("meta")["description"].content = "";
    next()
  }
});

export default router
